/** Straight and typographic apostrophe possessives (`'s` / `'s`). */
export const POSSESSIVE_SUFFIXES = ["'s", "\u2019s"] as const;

/** Trailing apostrophe only — `James'`, `Marcus'` (names already ending in s). */
export const TRAILING_POSSESSIVE_APOSTROPHE = ["'", "\u2019"] as const;

/** Extra characters after `at` when text continues with a possessive suffix. */
export function possessiveSuffixLength(text: string, at: number): number {
  for (const suffix of POSSESSIVE_SUFFIXES) {
    if (text.startsWith(suffix, at)) return suffix.length;
  }
  for (const apostrophe of TRAILING_POSSESSIVE_APOSTROPHE) {
    if (text.startsWith(apostrophe, at)) return apostrophe.length;
  }
  return 0;
}

/** Add possessive forms for Harper's custom dictionary. */
export function expandPossessiveNameForms(words: string[]): string[] {
  const out: string[] = [];
  for (const word of words) {
    const trimmed = word.trim();
    if (trimmed.length === 0) continue;
    out.push(trimmed);
    if (/[\p{L}\p{N}]$/u.test(trimmed) === false) continue;
    if (/['\u2019]/u.test(trimmed)) continue;
    for (const suffix of POSSESSIVE_SUFFIXES) {
      out.push(`${trimmed}${suffix}`);
    }
    if (/s$/i.test(trimmed)) {
      for (const apostrophe of TRAILING_POSSESSIVE_APOSTROPHE) {
        out.push(`${trimmed}${apostrophe}`);
      }
    }
  }
  return out;
}
